import React from 'react';

import Authenticated from 'Components/Layouts/Authenticated';
import { PrimaryButton } from "Components/Button";
import Link from "Components/Utilities/Link";
import { Container } from "Components/Utilities";
import { ModalTrigger } from "Components/Modal/index";
import Highlights from "Components/Partials/Modals/Highlights";
import { Link as DomLink } from "react-router-dom";

export default class Dashboard extends React.Component {
    render () {
        return (
            <Authenticated pageVideoHeader={ "bupa-banner.mp4" } title={"Dashboard"}>
                <div className="space-y-6 text-xl text-white bg-app-blue text-center py-5 lg:py-10">
                    <div className="text-4xl font-bold">
                        Join us for the Bupa Symposium 2025
                    </div>
                    <div className="text-2xl max-w-4xl mx-auto">
                        📅 15 October 2025 | 📍 QEII Centre, London
                    </div>
                </div>
                <Container>
                    <div className={ "pb-1 lg:pb-5 space-y-6 text-center mx-auto text-app-blue" }>
                        <div className="grid grid-cols-2 gap-4 mt-6 max-w-xl mx-auto text-white">
                            <DomLink to={ "/registration" } className="text-center text-xl md:text-3xl bg-app-light-blue py-10 font-bold col-span-2 rounded-xl">
                                Register Now
                            </DomLink>
                            <DomLink to={ "/information" } className="text-center text-xl md:text-3xl bg-app-darker-blue text-app-secondary-text py-10 font-bold rounded-xl">
                                Information
                            </DomLink>
                            <ModalTrigger
                                component={Highlights}
                            >
                                <div className="text-center text-xl md:text-3xl bg-app-lighter-blue py-10 font-bold rounded-xl">
                                   2024 Highlights
                                </div>
                            </ModalTrigger>
                        </div>
                    </div>
                </Container>
            </Authenticated>
        );
    }
}
